export default __webpack_public_path__ + "static/media/theme3net.03b8e41f.png";